import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { MsalGuard as AngularMsalGuard } from '@azure/msal-angular';
import { environment } from '@env/environment';
import { isRunningInIframe } from '@shared/utils/iframe-detection.util';

export const msalGuard: CanActivateFn = (route, state) => {
  if (!environment.enableMsalAuth) {
    return true;
  }

  // In iframe context, the loading-login flow owns authentication (silent SSO
  // or popup). This guard stays passive to avoid interfering with that flow.
  if (isRunningInIframe()) {
    return true;
  }

  const angularMsalGuard = inject(AngularMsalGuard, { optional: true });
  if (!angularMsalGuard) {
    console.warn('MsalGuard not available despite enableMsalAuth: true');
    return true;
  }

  return angularMsalGuard.canActivate(route, state);
};
